export default "__VITE_PUBLIC_ASSET__1e670ae7__"